import { __assign, __rest } from "tslib";
import { Button as MaterialButton, createStyles, fade, makeStyles, } from '@material-ui/core';
import React from 'react';
var useStyles = makeStyles(function (theme) {
    var padding = {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
    };
    var containedStyles = __assign(__assign({ boxSizing: 'border-box', minHeight: theme.spacing(5), borderRadius: theme.spacing(2.5) }, padding), { boxShadow: 'none', '&:disabled': {
            backgroundImage: 'none',
            backgroundColor: theme.palette.grey[400],
            color: theme.palette.common.white,
        } });
    var outlinedStyles = __assign(__assign({ boxSizing: 'border-box', minHeight: theme.spacing(5), borderRadius: theme.spacing(2.5) }, padding), { '&:disabled': {
            borderColor: theme.palette.grey[400],
            color: theme.palette.grey[400],
        } });
    return createStyles({
        root: {
            '& svg': {
                padding: 0,
                background: 'transparent',
            },
        },
        containedPrimary: __assign(__assign({}, containedStyles), { backgroundImage: "linear-gradient(90deg, " + theme.palette.primary.light + ", " + theme.palette.primary.main + ")" }),
        containedSecondary: __assign(__assign({}, containedStyles), { backgroundColor: theme.palette.secondary.main }),
        outlinedPrimary: __assign(__assign({}, outlinedStyles), { '&.Mui-focusVisible': {
                backgroundColor: fade(theme.palette.primary.main, 0.04),
                borderColor: theme.palette.primary.main,
            } }),
        outlinedSecondary: __assign(__assign({}, outlinedStyles), { '&.Mui-focusVisible': {
                backgroundColor: fade(theme.palette.secondary.main, 0.04),
                borderColor: theme.palette.secondary.main,
            } }),
        endIcon: {
            marginLeft: theme.spacing(2),
        },
        fullWidth: {
            '& .MuiButton-endIcon': {
                marginLeft: 'auto',
            },
        },
        text: {
            fontSize: theme.typography.button.fontSize,
            textTransform: 'initial',
            lineHeight: 1,
            letterSpacing: 0,
            fontWeight: 'bold',
            '&:hover': {
                background: 'transparent !important',
            },
        },
        startIcon: {
            marginRight: theme.spacing(0.3),
        },
        iconSizeMedium: {
            '& > *:first-child': {
                fontSize: theme.typography.body1.fontSize,
            },
        },
    });
});
export var Button = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, props = __rest(_a, ["children", "color", "variant"]);
    var classes = useStyles();
    return (React.createElement(MaterialButton, __assign({ size: "medium", classes: classes, color: color, variant: variant }, props, { ref: ref }), children));
});
//# sourceMappingURL=Button.js.map